import { Button, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { SupportedBankList } from '../../../modules/bank-connection/components/SupportedBankList';
import { useSafeNavigation } from '../../../hooks/useSafeNavigation';

export const CreateBankConnectionPage = () => {
  const { t } = useTranslation('bank-connection', { keyPrefix: 'create' });
  const { safeNavigate } = useSafeNavigation();
  const onSelect = (paymentProvider: string) => {
    safeNavigate(`/bank-connection/connect/${paymentProvider}`);
  };

  return (
    <>
      <DialogTitle>{t('title')}</DialogTitle>
      <DialogContent>
        <Typography mb={2}>{t('description')}</Typography>
        <SupportedBankList onSelect={onSelect} />
      </DialogContent>
      <DialogActions>
        <Button fullWidth component={Link} to="..">
          {t('back')}
        </Button>
      </DialogActions>
    </>
  );
};
